import { Box, List, Stack, Tab, Typography, useTheme } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { FunctionComponent, useEffect, useState } from 'react';
import {
    FaqsConfiguration,
    FaqGroupConfiguration,
    Faq,
} from '@starjack/entities/faq';
import { usePageData } from '@starjack/features/pageData';
import type { Theme } from '@mui/material/styles';

// Extended theme interface for widgets that expect app-specific theme properties
interface ExtendedTheme extends Theme {
    page: {
        verticalSpacing: number;
        backgroundColor: string;
        template: {
            base: {
                paddingX: number;
                paddingY: number;
            };
        };
    };
}

type FaqsPageContentProps = {
    canMutateFaq?: (faq: Faq) => boolean;
    liftOperatorId?: string;
};

export const FaqsPageContent: FunctionComponent<FaqsPageContentProps> = ({
    canMutateFaq,
    liftOperatorId,
}) => {
    const theme = useTheme() as ExtendedTheme;
    const [tavValue, setTaValue] = useState<'faqs' | 'groups'>('faqs');
    const { setPageData } = usePageData();

    const handleTabValueChange = (_, nextValue: 'faqs' | 'groups') => {
        setTaValue(nextValue);
    };

    useEffect(() => {
        setPageData({
            title: `FAQ's`,
            body: (
                <Typography>
                    So bleiben keine Fragen mehr offen: Hier können Sie für
                    Ihren Standard-Webshop eigene FAQ's, speziell für Ihre
                    Destination und zu Ihren Angeboten, erstellen.
                </Typography>
            ),
        });
    }, [setPageData]);

    return (
        <TabContext value={tavValue}>
            <Typography
                sx={{
                    mb: 8,
                }}
                variant='h4'
            >
                FAQ&apos;s
            </Typography>
            <Stack spacing={theme.page.verticalSpacing}>
                <Box>
                    <Typography
                        sx={{
                            fontWeight: 500,
                        }}
                    >
                        Funktionen im Überblick:
                    </Typography>

                    <List
                        sx={{
                            ml: 3,
                            listStyleType: 'disc',
                        }}
                        component='ul'
                    >
                        <li>
                            Fragen und Antworten (FAQ) zu Ihrer Destination in
                            Deutsch/Englisch
                        </li>
                        <li>
                            Themenbereiche anlegen, unter denen die FAQs
                            strukturiert ausgegeben werden
                        </li>
                        <li>FAQs auf bestimmten Unterseiten ausgeben</li>
                    </List>
                </Box>

                <Box
                    sx={{
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <TabList onChange={handleTabValueChange}>
                        <Tab label={"FAQ's"} value='faqs' />
                        <Tab label='Themenbereiche' value='groups' />
                    </TabList>
                </Box>
            </Stack>

            <TabPanel value='faqs'>
                <FaqsConfiguration
                    canMutateFaq={canMutateFaq}
                    liftOperatorId={liftOperatorId}
                />
            </TabPanel>
            <TabPanel value='groups'>
                <FaqGroupConfiguration />
            </TabPanel>
        </TabContext>
    );
};
